<template>
    <div class="right">
        <div>
            <el-popover
                placement="left"
                title="24小时电话咨询"
                :width="200"
                trigger="hover"
                content="13226446887"
            >
                <template #reference>
                    <i class="iconfont icon-31dianhua"></i>
                </template>
            </el-popover>
        </div>
        <div>
            <el-popover placement="left" title="添加微信咨询" :width="200" trigger="hover">
                <template #reference>
                    <i class="iconfont icon-erweima"></i>
                </template>
                <template #default>
                    <div
                        class="demo-rich-conent"
                        style="display: flex; gap: 16px; flex-direction: column"
                    >
                        <img
                            :size="60"
                            src="../assets/images/24990852.png"
                        />
                    </div>
                </template>
            </el-popover>
        </div>
        <div>
            <el-popover
                placement="left"
                title="QQ在线咨询"
                :width="200"
                trigger="hover"
                content="572322955"
            >
                <template #reference>
                    <i class="iconfont icon-qq"></i>
                </template>
            </el-popover>
        </div>
        <div>
            <i class="iconfont icon-huidaodingbu" @click="backtop"></i>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AppRight',
  setup () {
    const backtop = () => {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }
    return { backtop }
  }
}
</script>

<style scoped lang="less">
.right {
  position: fixed;
  right: 0;
  top: 50%;
  border-radius: 16px 0 0 16px;
  overflow: hidden;
  z-index: 100;
  > div {
    background-color: #76c7c0;
    padding: 10px 10px 10px 12px;
    &:hover {
      background-color: #44efc2;
    }
  }
  .iconfont {
    font-size: 32px;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
